import {Mapping} from "../mapping";

export abstract class OperationHandler {

  protected constructor(public mapping: Mapping) {
  }

  abstract operate(target: object): PropertyDescriptor;
}
